module.exports = __webpack_public_path__ + "static/img/home_buffer_photo3@2x.65083d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_buffer_photo3@2x.png
// module id = pwZH
// module chunks = 0